import { FC } from "react";
import { useTranslation, Trans } from "react-i18next";
import clsx from "clsx";
import { IconP2p } from "~/components";

interface Props {
    rate?: number;
}

const Component: FC<Props> = ({ rate = 0 }) => {
    const { t } = useTranslation();

    return (
        <div
            className={clsx(
                "rounded-[12px] bg-bg_0 border-[0.5px] border-border_2 p-3",
            )}
        >
            <div className="flex">
                <IconP2p className="text-brand_1 text-[24px]" />
                <div className="ml-2">
                    <div className="text-body1 font-Semibold text-text_1">
                        <Trans
                            i18nKey="rebate_desc_title"
                            values={{ num: `${rate}%` }}
                        />
                    </div>
                    <div className="text-body3 font-Regular text-text_2 mt-[2px]">
                        {t("rebate_desc_desc")}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Component;
